declare global {
  interface Window {
    dataLayer: any;
  }
}

declare const defaultFuelOption: string;

import { smallDevice } from "./util";
import CrownForm, { Response } from "./CrownForm";
import { updateCarbonSavings } from "./co2-savings";
import Tracking from "./Tracking";
import "@markshall/tank-size-calc-custom-element/dist/tank-size-calculator";
import "@markshall/tank-size-calc-custom-element/dist/volume-converter";

const consentEvt = (e: Event) => {
  const acceptedCategories = (<CustomEvent>e).detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

let subMenuId = 0;

/* NAVIGATION */
type NavigationState = "static" | "open" | "back" | "opensubmenu";
const toggleNavButton = (state: NavigationState, submenu: HTMLElement | null = null) => {
  const hamburger = document.querySelector(".hamburger");
  const text = document.querySelector(".burger--text");

  if (!hamburger || !text) return;

  if (state === "static") {
    hamburger.classList.add("state-open");
    text.textContent = "Close";
    document
      .querySelectorAll(".nav, .nav > .nav-main")
      .forEach((el) => el.classList.add("opened"));
    document.body.classList.add("no-scroll");
  } else if (state === "open") {
    hamburger.classList.remove("state-open");
    text.textContent = "Menu";
    document
      .querySelectorAll(".nav, .nav > .nav-main")
      .forEach((el) => el.classList.remove("opened"));
    document.body.classList.remove("no-scroll");
  } else if (state === "back") {
    document
      .querySelectorAll(
        `.dropdown-window.opened.level-${subMenuId}, .dropdown-window.level-${subMenuId} .nav-main.opened`,
      )
      .forEach((el) => el.classList.remove("opened"));
    document
      .querySelector(`.dropdown-toggle.level-${subMenuId}.active`)
      ?.classList.remove("active");

    if (subMenuId < 2) {
      hamburger.classList.remove("state-back");
      hamburger.classList.add("state-open");
      text.textContent = "Close";
    }

    subMenuId--;
  } else if (state === "opensubmenu" && submenu) {
    if (submenu.classList.contains("opened")) {
      return;
    }

    // `subMenuId++` keeps incrementing when toggling between
    // nested dropdowns, so short-circuit this behaviour
    subMenuId <= 1 && subMenuId++;

    if (subMenuId < 2) {
      hamburger.classList.add("state-back");
      hamburger.classList.remove("state-open");
      text.textContent = "Back";
    }

    submenu
      .querySelector(".nav-main")
      ?.classList.add("opened");
    submenu.classList.add("opened");
  } else {
    throw new Error(`Invalid button state "${state}"`);
  }

  hamburger.classList[subMenuId > 1 ? "add" : "remove"]("level-2");
};

const hamburger = document.querySelector(".hamburger");
if (hamburger) {
  hamburger.addEventListener("click", function(e) {
    e.preventDefault();

    let burgerState: NavigationState;

    if (this.classList.contains("state-open")) {
      burgerState = "open";
    } else if (this.classList.contains("state-back")) {
      burgerState = "back";
    } else {
      burgerState = "static";
    }


    toggleNavButton(burgerState);
  });
}

if (document.querySelector(".nav")) {
  document.querySelector(".nav")?.addEventListener("click", (e) => {
    const clickedEl = e.target as HTMLElement;

    if (
      clickedEl.nodeName === "A" &&
      clickedEl.parentElement?.classList.contains("dropdown-toggle")
    ) {
      e.preventDefault();

      const _parent = clickedEl.parentElement;
      const subMenu = _parent.querySelector<HTMLElement>(".dropdown-window");

      if (_parent.classList.contains("root")) {
        document
          .querySelectorAll(".dropdown-window.opened")
          .forEach((el) => el.classList.remove("opened"));
        document
          .querySelectorAll(".dropdown-toggle.active")
          .forEach((el) => el.classList.remove("active"));
        subMenuId = 0;
      }

      // close any opened nested dropdowns
      document
        .querySelectorAll(".level-2.active")
        .forEach((el) => el.classList.remove("active"));
      document
        .querySelectorAll(".level-2.opened")
        .forEach((el) => el.classList.remove("opened"));

      _parent.classList.add("active");

      subMenu && toggleNavButton("opensubmenu", subMenu);
    }
  });
}
/* NAVIGATION */

document.querySelectorAll(".tabs").forEach((tabs) => {
  const items = tabs.querySelectorAll(".tabs__item");
  const panels = tabs.querySelectorAll(".tabs__panel");

  items.forEach((item, idx) => {
    item.addEventListener("click", () => {
      items.forEach((item) => item.classList.remove("tabs__item--active"));
      panels.forEach((panel) => panel.classList.remove("tabs__panel--active"));

      items[idx].classList.add("tabs__item--active");
      panels[idx].classList.add("tabs__panel--active");
    });
  });
});

const targets = document.querySelectorAll(".co2-savings-label");
const intervals = new Map();
const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      intervals.set(
        entry.target,
        setInterval(
          updateCarbonSavings.bind(null, entry.target as HTMLElement),
          1000,
        ),
      );
    } else {
      clearInterval(intervals.get(entry.target));
      intervals.delete(entry.target);
    }
  }
});

for (const label of targets) {
  updateCarbonSavings(label as HTMLElement);

  observer.observe(label);
}

const brochureForm = document.querySelector<HTMLFormElement>(
  "#brochureDownloadForm",
);

if (brochureForm) {
  new CrownForm({
    el: brochureForm,

    url: "/wp-content/themes/crownoil/ajax/BrochureDownload.php",

    button: {
      submittingText: "Download brochure...",
      defaultText: "Download Brochure",
    },

    success: function() {
      const fileUrl =
        document.querySelector<HTMLInputElement>("#brochureFileUrl")?.value;

      window.open(fileUrl);

      this.el.reset();

      document
        .querySelector<HTMLDialogElement>("#brochureDownload")
        ?.close();
    },
  });

  [...document.querySelectorAll(".modal__close")].forEach((closeBtn) =>
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      closeBtn.closest<HTMLDialogElement>(".modal")?.close();
    }),
  );

  [...document.querySelectorAll("[href=\"#brochure\"]")].forEach((cta) => {
    cta.addEventListener("click", (e) => {
      e.preventDefault();
      document
        .querySelector<HTMLDialogElement>("#brochureDownload")
        ?.showModal();
    });
  });

  document.querySelector("#brochure-tcpp")?.addEventListener("input", (e) => {
    e.preventDefault();

    const checkbox = e.target as HTMLInputElement;
    const button = checkbox
      ?.closest("form")
      ?.querySelector(".form__button--submit");

    if (checkbox.checked && button) {
      button.removeAttribute("disabled");
    } else {
      button?.setAttribute("disabled", "disabled");
    }
  });
}

document.addEventListener("keyup", (e) => {
  const { key } = e;

  if (
    key === "Escape" &&
    document.querySelector(".nav")?.classList.contains("opened")
  ) {
    document.querySelector(".hamburger")?.dispatchEvent(new Event("click"));
  } else if (key === "/") {
    if (document.querySelector("#wpadminbar")) {
      document.querySelector("#wpadminbar")?.remove();
    }
  }
});

window.addEventListener("click", (e) => {
  const el = e.target as HTMLElement;
  if (
    el.classList.contains("dropdown-window") ||
    el.classList.contains("nav")
  ) {
    document.querySelector(".hamburger")?.dispatchEvent(new Event("click"));
  }
});

// Observe benefits blocks
const blocksObserver = new IntersectionObserver(
  (entries, blocksObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.classList.add("animate");
      blocksObserver.unobserve(entry.target);
    });
  },
  {
    threshold: 0.35,
  },
);

document
  .querySelectorAll(".icon-block svg")
  .forEach((el) => blocksObserver.observe(el));

// Observe trigger to shrink header and show back to top button
const headerTrigger = document.querySelector(".headerTrigger");
if (headerTrigger) {
  new IntersectionObserver(
    ([headerTrigger]) => {
      document.body.classList[headerTrigger.isIntersecting ? "remove" : "add"](
        "header-following",
      );
    },
    {
      threshold: 0.5,
    },
  ).observe(headerTrigger);
}

// accordion toggle all
const accordionToggleAllBtns = document.querySelectorAll<HTMLButtonElement>(
  ".accordion__toggle-all",
);
for (let btn of accordionToggleAllBtns) {
  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const state = btn.dataset.accordionState;

    const accordionsInSection =
      btn.parentElement?.querySelectorAll(".accordion") || [];

    for (let accordion of accordionsInSection) {
      // on page load, no state will be set
      if (!state || state === "closed") {
        accordion.setAttribute("open", "open");
        btn.innerText = "Toggle All -";
        btn.dataset.accordionState = "open";
      } else {
        accordion.removeAttribute("open");
        btn.innerText = "Toggle All +";
        btn.dataset.accordionState = "closed";
      }
    }
  });
}

if (document.body.classList.contains("inner-page") && !smallDevice()) {
  const form = document.querySelector(".quote-form");
  const footer = document.querySelector("footer");

  if (form && footer) {
    new IntersectionObserver(
      (entries) => {
        form?.classList[entries[0].isIntersecting ? "add" : "remove"](
          "bottom-stuck",
        );
      },
      {
        threshold: 0.1,
      },
    ).observe(footer);
  }
}

const newsletterFormEl =
  document.querySelector<HTMLFormElement>("#newsletter-form");
if (newsletterFormEl) {
  new CrownForm({
    el: newsletterFormEl,

    url: "/wp-content/themes/crownoil/ajax/NewsletterForm.php",

    success() {
      CrownForm.addSuccess("Thank you for subscribing to our newsletter!", "#newsletter-email");
    },

    button: {
      submittingText: "Signing up...",
      defaultText: "Sign Up",
    },
  });
}

/* QUOTE FORM */
const quoteFormEl = document.querySelector<HTMLFormElement>("#quote-form");
if (quoteFormEl) {
  const quoteForm = new CrownForm({
    el: quoteFormEl,

    url: "/wp-content/themes/crownoil/ajax/Quote.php",

    button: {
      submittingText: "Getting your quote...",
      defaultText: "Get My Quote",
    },

    success(response: Response) {
      const fuel = encodeURIComponent(
        response.form_data.fuel || "",
      );

      window.dataLayer?.push({
        event: "formSubmit",
        formId: "quote-form",
        fuel: response.form_data.fuel,
        litres: response.form_data.litres,
        customer_type: response.form_data["customer-type"],
        out_of_area: "In Area",
      });

      window.location.href = `/thank-you/?fuel=${fuel}`;
    },

    error(response: Response) {
      const { code = "N/A", data = "N/A" } = response.error;
      let out_of_area = false;

      let destination = null;

      if (code === "OUT_OF_AREA") {
        destination = "/quote-request-sorry/";
        out_of_area = true;
      }

      if (destination) {
        window.dataLayer?.push({
          event: "formSubmit",
          formId: "quote-form",
          fuel: response.form_data.fuel,
          litres: response.form_data.litres,
          customer_type: response.form_data["customer-type"],
          out_of_area: out_of_area ? "Out of Area" : "In Area",
        });

        window.location.href = destination;
      } else {
        this.addError(`An error occurred and we're not sure why. Please try again, or contact us with the following code/message:<br /><br />
  Code: ${code}<br />
  Message: ${JSON.stringify(data)}`);
      }
    },
  });

  if (quoteForm.el) {
    function updateLitresOptions(product: string) {
      let litresOpts: string[];

      if (product === "Kerosene / Heating Oil") {
        litresOpts = [
          "500",
          "750",
          "1,000",
          "1,250",
          "1,500",
          "1,750",
          "2,000",
          "2,299",
          "2,300+",
        ];
      } else if (product === "Lubricants") {
        litresOpts = [
          "25",
          "205",
          "1,500-2,000",
          "2,001-2,500",
          "2,501-3,000",
          "3,001+",
        ];
      } else if (product === "Red Diesel") {
        litresOpts = [
          "500-999",
          "1,000-1,999",
          "2,000-2,300",
          "2,301-3,999",
          "4,000-5,999",
          "6,000-7,999",
          "8,000-9,999",
          "10,000-14,999",
          "15,000-19,999",
          "20,000-24,999",
          "25,000-35,999",
          "36,000+",
        ];
      } else if (product === "AdBlue") {
        litresOpts = [
          "25",
          "205",
          "1,500-2,000",
          "2,001-2,500",
          "2,501-3,000",
          "3,001+",
        ];
      } else {
        litresOpts = [
          "1,000-1,999",
          "2,000-2,300",
          "2,301-3,999",
          "4,000-5,999",
          "6,000-7,999",
          "8,000-9,999",
          "10,000-14,999",
          "15,000-19,999",
          "20,000-24,999",
          "25,000-35,999",
          "36,000+",
        ];
      }

      if (quoteForm.el.querySelector("#quote-litres")) {
        const litresSelect =
          quoteForm.el.querySelector<HTMLSelectElement>("#quote-litres");

        let litresHtml = "<option value=\"\" disabled selected>Select</option>";

        litresOpts.forEach((el) => (litresHtml += `<option value="${el}">${el}</option>`));

        if (litresSelect) {
          litresSelect.innerHTML = litresHtml;
        }
      }
    }

    quoteForm.el
      .querySelector("#quote-fuel")
      ?.addEventListener("change", (e) =>
        updateLitresOptions((e.target as HTMLSelectElement).value),
      );

    // select default fuel option and set correct litres options
    if (typeof defaultFuelOption !== "undefined" && defaultFuelOption) {
      const fuel = quoteForm.el.querySelector<HTMLSelectElement>("#quote-fuel");
      if (fuel) {
        const fuelIndex = [...fuel.options].findIndex(
          (el: HTMLOptionElement) => el.value === defaultFuelOption,
        );

        if (fuelIndex) {
          fuel.selectedIndex = fuelIndex;
          updateLitresOptions(defaultFuelOption);
        }
      }
    }
  }
}
/* QUOTE FORM */

const serviceForm = document.querySelector<HTMLFormElement>("#service-form");
if (serviceForm) {
  new CrownForm({
    el: serviceForm,

    url: "/wp-content/themes/crownoil/ajax/ServiceForm.php",

    button: {
      submittingText: "Getting your quote...",
      defaultText: "Get My Quote",
    },

    success(response: Response) {
      const service = encodeURIComponent(
        document.querySelector<HTMLInputElement>("#service-service")?.value ||
        "",
      );

      window.dataLayer?.push({
        event: "formSubmit",
        formId: "service-form",
        service: response.form_data.service,
      });

      window.location.href = `/thank-you/?service=${service}`;
    },
  });
}

let crown = [],
  crownLogo = "";
crown.push("                  `...---:::::----..`             ");
crown.push("              `.-:::::::::::::::::::::--.`        ");
crown.push("           .-:::::::::::::::::::::::::::::-.`     ");
crown.push("        `-:::::::::::::::::::::::::::::::::::-`   ");
crown.push("      `-:::::::::::::::::::::::::::::::::::::::-` ");
crown.push("     .:::::::::::::::::::-...::::::::::::::::::::-");
crown.push("   `-::::::::::::::::::::.   -::::::::::::::::::::");
crown.push("  `-::::::::::::::::::::::-.-:::::::::::::::::::::");
crown.push("  -:::::--:::::::::::::::::-:::::::::::::::::---::");
crown.push(" -::::-   -:::::::::::::::- .:::::::::::::::-`  .:");
crown.push("`:::::-```-:-::::::::::::-`  -::::::::::::---.``-:");
crown.push("-::::::::::-.``.-:::::::-`    -:::::::--``.-::::::");
crown.push("-::::::::::::-`  `-::::-`      .::::-.   -::::::::");
crown.push("::::::::::::::-`   `-:.         `--.    -:::::::::");
crown.push("-::::::::::::::-`                      -::::::::::");
crown.push("-:::::::::::::::-                     .:::::::::::");
crown.push("`::::::::::::::::.                   `::::::::::::");
crown.push(" -:::::::::::::::-                   .::::::::::::");
crown.push(" `-:::::::::::::::`                  -::::::::::::");
crown.push("  `-::::::::::::::.                 `:::::::::::::");
crown.push("   `-:::::::::::::-                 `:::::::::::::");
crown.push("     -::::::::::::-`````````````````.:::::::::::::");

crown.forEach((i) => (crownLogo += i + "\n"));

console.log(
  "%c" + crownLogo,
  "font-family: monospace; color: #d8222a; font-size: 14px",
);
